import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { getDashArray } from '../../../helpers/utils';
import HookablePoint from '../HookablePoint';

export function Circle(props: any) {
  const {
    x,
    y,
    radius,
    fillingColor,
    lineColor,
    lineType = 'solid',
    arn,
    latitude,
    longitude,
    hookProperties,
    labelFontSize,
  } = props;
  const [isHooked, setIsHooked] = useState({
    isPrimaryHooked: false,
    isSecondaryHooked: false,
  });
  const { primaryHookId, secondaryHookId } = useSelector(
    (state: any) => state.executor.hookedItems
  );
  useEffect(() => {
    setIsHooked({
      isPrimaryHooked: primaryHookId === arn,
      isSecondaryHooked: secondaryHookId === arn,
    });
  }, [primaryHookId, secondaryHookId]);
  return (
    <>
      <circle
        cx={x}
        cy={y}
        r={radius}
        fill={fillingColor}
        stroke={lineColor}
        strokeDasharray={getDashArray(lineType)}
        pointerEvents="visibleStroke"
      />
      <HookablePoint
        x={x}
        y={y}
        radius={2}
        id={arn}
        latitude={latitude}
        longitude={longitude}
        hookProperties={hookProperties}
      />
      <text
        x={x}
        y={y - radius - 10}
        textAnchor="middle"
        strokeWidth="1px"
        fontSize={labelFontSize || '0.5em'}
        fill={lineColor}
      >
        {arn?.toUpperCase()}
      </text>
    </>
  );
}
